import type { ReactNode } from "react";

type OverlineProps = {
  children: ReactNode;
  /** Use on deep navy bands: cyan is only legible as accent on dark. */
  onDark?: boolean;
  className?: string;
};

export function Overline({ children, onDark = false, className = "" }: OverlineProps) {
  return (
    <p
      className={`font-display text-[13px] font-semibold uppercase leading-4 tracking-[0.2em] ${
        onDark ? "text-secondary" : "text-brand-deep-water"
      } ${className}`}
    >
      {children}
    </p>
  );
}
